import React from 'react';

const SvgActions3 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 18 18" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M5.5 10H8v2.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V10h2.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H10V5.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V8H5.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5zM16 16H2V2h14zm0-16H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgActions3 svgRef={ref} {...props} />);
export default ForwardRef;
